import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus, Mail } from "lucide-react";
import { FAQ, CONTACT } from "../../data/tilio";
import { Reveal, SectionHeading } from "./Shared";

const FaqItem = ({ q, a, testId }) => {
    const [open, setOpen] = useState(false);
    return (
        <div className="border-b border-stone/70" data-testid={testId}>
            <button
                data-testid={`${testId}-trigger`}
                onClick={() => setOpen(!open)}
                className="flex w-full items-center justify-between gap-6 py-4 text-left"
                aria-expanded={open}
            >
                <span className="text-[17px] font-medium text-pine">{q}</span>
                <Plus
                    className={`h-5 w-5 shrink-0 text-sage transition-transform duration-300 ${open ? "rotate-45" : ""}`}
                    strokeWidth={1.25}
                />
            </button>
            <AnimatePresence initial={false}>
                {open && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden"
                    >
                        <p className="pb-5 text-[17px] leading-[1.6] text-sage">{a}</p>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

const FaqCategory = ({ cat, ci, delay }) => {
    const [open, setOpen] = useState(false);
    return (
        <Reveal delay={delay}>
            <h3 className="contents">
                <button
                    data-testid={`faq-category-${ci}`}
                    onClick={() => setOpen(!open)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-6 border-b border-pine pb-4 text-left"
                >
                <span className="font-serif text-2xl tracking-tight text-pine">{cat.category}</span>
                <Plus
                    className={`h-5 w-5 shrink-0 text-sage transition-transform duration-300 ${open ? "rotate-45" : ""}`}
                    strokeWidth={1.25}
                />
                </button>
            </h3>
            <AnimatePresence initial={false}>
                {open && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden"
                    >
                        <div className="pt-2">
                            {cat.items.map((item, qi) => (
                                <FaqItem key={item.q} q={item.q} a={item.a} testId={`faq-item-${ci}-${qi}`} />
                            ))}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </Reveal>
    );
};

export default function Faq() {
    return (
        <section id="faq" data-testid="faq-section" className="border-t border-stone/70 bg-[#F5F8F4]">
            <div className="mx-auto max-w-6xl px-6 py-24 lg:px-10 lg:py-32">
                <SectionHeading
                    number="08"
                    eyebrow="Wszystko, co warto wiedzieć"
                    title="Informacje praktyczne"
                    center
                    testId="faq-heading"
                />
                <div className="mt-14 grid grid-cols-1 items-start gap-x-16 gap-y-14 lg:grid-cols-2">
                    {FAQ.map((cat, ci) => (
                        <FaqCategory key={cat.category} cat={cat} ci={ci} delay={(ci % 2) * 0.08} />
                    ))}
                </div>
                <Reveal className="mt-16 text-center">
                    <p className="text-[17px] text-sage">Nie znalazłeś odpowiedzi na swoje pytanie?</p>
                    <a
                        data-testid="faq-contact-btn"
                        href={`mailto:${CONTACT.email}`}
                        className="btn-primary mt-5"
                    >
                        <Mail className="h-4 w-4" strokeWidth={1.25} />
                        Napisz do nas
                    </a>
                </Reveal>
            </div>
        </section>
    );
}
